<template>
<div class="alter">
    <el-dialog
    :close-on-click-modal="false"
  :center="true"
  title="修改密码"
  :visible.sync="dialogVisible"> 
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
  <el-form-item prop="oldPassword">
    <el-input type="password" maxlength="20" v-model="ruleForm.oldPassword" placeholder="请输入旧密码">
    </el-input>
  </el-form-item>
   <el-form-item prop="newPassword">
    <el-input type="password" max="20" v-model="ruleForm.newPassword" placeholder="设置新密码" ></el-input>
  </el-form-item>
   <el-form-item prop="repeatPassword">
    <el-input type="password" max="20" v-model="ruleForm.repeatPassword" placeholder="请再次输入您设置的新密码"></el-input>
  </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false" class="el-bus">取 消</el-button>
    <el-button type="primary" @click="submitForm()">确 定</el-button>
  </span>
</el-dialog>
</div>
</template>
<script>
import {auth_resetpwd} from '../api/index'
let Base64 = require('js-base64').Base64;
export default {
 data() {
           var validatePass = (rule, value, callback)=>{
                if(this.ruleForm.newPassword===value) {
                     callback();
                }else {
                     callback(new Error('两次填写密码不一致'));
                }
           }
           var validatePassword=(rule, value, callback)=>{
                  var reg= /^(?![A-Za-z]+$)(?!\d+$)(?![\W_]+$)\S{8,20}$/
                  let n=reg.test(value);
                  if(n){
                       callback()
                  }else{
                       callback(new Error('密码必须为8位以上，包含英文、数字、符号至少两种组合'))
                  }
                  
           }
     return {
         dialogVisible:false,
         ruleForm:{
             oldPassword:'',
             repeatPassword:'',
             newPassword:'',
             repeat:false,
         },
          rules: {
          oldPassword:[{
              required: true, message: '请输入旧密码', trigger: 'blur',
          }],
          newPassword:[
              { required: true, message: '请输入新密码', trigger: 'blur',},
              {
                 validator: validatePassword, trigger: 'blur',
              }
          ],
          repeatPassword:[
             { required: true,validator: validatePass, trigger: 'blur' }   
          ]
          }
     }
 },
 methods: {
      submitForm(){
           this.$refs['ruleForm'].validate((valid) => {
            if(valid) {
                if(this.repeat){
                    return this.repeat=true; 
                }
                let p={
                    old_password:Base64.encode(this.ruleForm.oldPassword),
                    new_password:Base64.encode(this.ruleForm.newPassword),
                    confirm_password:Base64.encode(this.ruleForm.repeatPassword),
                }
                this.repeat=true; 
                 auth_resetpwd(p).then((res) =>{
                   this.repeat=false;
                   if(res.data.code===200){
                     this.$refs['ruleForm'].resetFields();
                     this.dialogVisible=false;
                     this.$point('密码修改成功')
                   }else{
                    //   this.$refs['ruleForm'].resetFields();
                    //   this.dialogVisible=false;
                    //    this.$point(res.data.message)
                    this.$refs.ruleForm.fields[0].error = res.data.message;
                   }
                 })
            }else {
                console.log('密码验证有误')
            }
        });
      }
 },
 watch:{

 }
}
</script>

<style lang="scss" scoped>
.alter /deep/.el-dialog{
   width: 480px;
   height:366px;
    padding: 30px 40px 27px 40px;
    box-sizing: border-box;
   .el-dialog__header{ 
       padding: 0px;
       margin-bottom: 33px;;
       .el-dialog__title{
         font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        letter-spacing: 0px;
       }
       .el-dialog__headerbtn {
           top:32px;
       }
   }
   .el-dialog__body{
       padding: 0px;
       .is-error{
           .el-input__inner{
               border-color:rgba(255,0,77,1)
           }
       }
       .el-form-item{
           margin-bottom:20px;
           .el-input__inner{
               padding: 0px 0px;
            border-top-width: 0px;
            border-left-width: 0px;
            border-right-width: 0px;
            border-bottom-width: 1px;
            border-radius: 0px;
           }
           .el-form-item__error{
               font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: LEFT;
                color: #ff004d;
           }
       }
   }
   .el-dialog__footer{
       padding: 25px 0px 0px 0px;
      .el-button {
          width: 180px;
          height:40px;
          font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        // text-align: LEFT;
        border-radius: 2px;
        line-height: 14px;
      }
      .el-bus{
          background: #f4f4f4;
          color: #666666;
      }
       
   }
  }
</style>


// WEBPACK FOOTER //
// src/components/ChangePassword.vue